import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TooltipContent } from "@faire/retailer-visitor-shared/features/PointOfSale/components/PDPInventory/TooltipContent";
import { POSLogo } from "@faire/retailer-visitor-shared/features/PointOfSale/components/POSLogo";
import { Tooltip } from "@faire/retailer-visitor-shared/features/PointOfSale/components/Tooltip";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { Row } from "@faire/web--source/slate/Layout";
import { TooltipTypography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IGetProductOptionInventoryRequest } from "@faire/web-api--source/indigofair/retailers/pos/IGetProductOptionInventoryRequest";
import { useQuery_escape_hatch as useInventoryQuery } from "@faire/web-api--source/retailers-pos-api/product-option-inventory/post-hooks";
import React, { useMemo } from "react";
export var ProductOptionPOSInventory = function(param) {
    var optionToken = param.optionToken;
    var _usePOSSummary = usePOSSummary(), type = _usePOSSummary.type, posCompanyName = _usePOSSummary.name, hasLinkedPOS = _usePOSSummary.hasLinkedPOS;
    var data = useInventoryQuery(IGetProductOptionInventoryRequest.build({
        product_option_tokens: [
            optionToken
        ]
    }), {
        enabled: hasLinkedPOS
    }).data;
    var inventoryCountNumber = useMemo(function() {
        var _data_inventory_data_by_product_option_optionToken;
        return data === null || data === void 0 ? void 0 : (_data_inventory_data_by_product_option_optionToken = data.inventory_data_by_product_option[optionToken]) === null || _data_inventory_data_by_product_option_optionToken === void 0 ? void 0 : _data_inventory_data_by_product_option_optionToken.total_inventory;
    }, [
        data,
        optionToken
    ]);
    if (!hasLinkedPOS || inventoryCountNumber === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Tooltip, {
        target: /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            gap: 4,
            children: [
                /*#__PURE__*/ _jsx(POSLogo, {
                    type: type
                }),
                /*#__PURE__*/ _jsx(TooltipTypography, {
                    style: {
                        cursor: "default"
                    },
                    children: inventoryCountNumber > 99 ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "xXpyaW",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "99+ in "
                            },
                            {
                                type: 1,
                                value: "posCompanyName"
                            }
                        ],
                        values: {
                            posCompanyName: posCompanyName
                        }
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "AAVLrR",
                        defaultMessage: [
                            {
                                type: 6,
                                value: "inventoryCountNumber",
                                options: {
                                    one: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " in "
                                            },
                                            {
                                                type: 1,
                                                value: "posCompanyName"
                                            }
                                        ]
                                    },
                                    other: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " in "
                                            },
                                            {
                                                type: 1,
                                                value: "posCompanyName"
                                            }
                                        ]
                                    }
                                },
                                offset: 0,
                                pluralType: "cardinal"
                            }
                        ],
                        values: {
                            inventoryCountNumber: inventoryCountNumber,
                            posCompanyName: posCompanyName
                        }
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(TooltipContent, {})
    });
};
